import Vue from 'vue'
import Router from 'vue-router'
import Axios from '../http/api'
const Index = resolve => require(['../components/scan/index.vue'], resolve); //扫码首页（就是传说中的橙色版）
const Coupondraw = resolve => require(['../components/scan/Coupondraw.vue'], resolve); //领取优惠券
const Couponshow = resolve => require(['../components/scan/Couponshow.vue'], resolve); //显示优惠券
const Countdown = resolve => require(['../components/scan/Countdown.vue'], resolve); //按摩倒计时
const Charging = resolve => require(['../components/scan/Charging.vue'], resolve); //开始充电
const Breakdown = resolve => require(['../components/scan/Breakdown.vue'], resolve); //开始充电 橙色
const Agreement = resolve => require(['../components/scan/Agreement.vue'], resolve); //用户协议
const fenxiang = resolve => require(['../components/scan/fenxiang.vue'], resolve); //为了错误的分享地址新建的空界面，跳转到正确的地址
const moliIndex = resolve => require(['../components/moli/index'], resolve); //魔力空间首页
const newmoliIndex = resolve => require(['../components/newmoli/index'], resolve); //魔力空间首页
const newmolilogin = resolve => require(['../components/newmoli/login'], resolve); //魔力空间首页
const newmolicoupon = resolve => require(['../components/newmoli/coupon'], resolve); //魔力空间首页
const newmoliCountdown = resolve => require(['../components/newmoli/countdown.vue'], resolve); //按摩倒计时
const moliCoupondraw = resolve => require(['../components/moli/Coupondraw.vue'], resolve); //领取优惠券
const moliCouponshow = resolve => require(['../components/moli/Couponshow.vue'], resolve); //显示优惠券
const moliCountdown = resolve => require(['../components/moli/Countdown.vue'], resolve); //按摩倒计时
const moliCharging = resolve => require(['../components/moli/Charging.vue'], resolve); //开始充电
const moliBreakdown = resolve => require(['../components/moli/Breakdown.vue'], resolve); //开始充电 橙色
const moliAgreement = resolve => require(['../components/moli/Agreement.vue'], resolve); //用户协议
const moliMineCoupon = resolve => require(['../components/moli/MineCoupon'], resolve); //我的优惠券
const mindaBreakdown = resolve => require(['../components/minda/breakdown.vue'], resolve); //开始充电
const shareBreakdown = resolve => require(['../components/share/breakdown.vue'], resolve); //开始充电 绿色
const royalBreakdown = resolve => require(['../components/royal/breakdown.vue'], resolve); //开始充电 皇家按摩
const aibenBreakdown = resolve => require(['../components/aiben/breakdown.vue'], resolve); //开始充电 爱奔
const mindaindex = resolve => require(['../components/minda/index.vue'], resolve); //民大创联页面
const mindaCountdowns = resolve => require(['../components/minda/mindaCountdown.vue'], resolve); //民大创联页面
const Login = resolve => require(['../components/login/Login'], resolve); //登录页面
const moliLogin = resolve => require(['../components/login/molilogin'], resolve); //登录页面
const MineInfo = resolve => require(['../components/mine/MineInfo'], resolve); //个人信息编辑
const MineLogin = resolve => require(['../components/mine/MineLogin'], resolve); //个人中心
const MinePoint = resolve => require(['../components/mine/MinePoint'], resolve); //积分
const MineBill = resolve => require(['../components/mine/MineBill'], resolve); //我的消费账单
const MineCoupon = resolve => require(['../components/mine/MineCoupon'], resolve); //我的优惠券
const Feedback = resolve => require(['../components/mine/Feedback'], resolve); //意见反馈
const UserGuide = resolve => require(['../components/mine/UserGuide'], resolve); //用户指南
const sharegift = resolve => require(['../components/mine/sharegift'], resolve); //分享有礼
const sharerule = resolve => require(['../components/mine/sharerule'], resolve); //分享活动规则
const minegift = resolve => require(['../components/mine/minegift'], resolve); //获得奖励
const LoginAiben = resolve => require(['../components/aiben/LoginAiben'], resolve); //爱奔-登录页面
const AibenIndex = resolve => require(['../components/aiben/index'], resolve); //爱奔首页
const AibenCountdown = resolve => require(['../components/aiben/aibencount'], resolve); //爱奔倒计时
const AibenCoupon = resolve => require(['../components/aiben/AibenCoupon'], resolve); //爱奔优惠券
const Aibenweihu = resolve => require(['../components/aiben/aibenweihu'], resolve); //爱奔优惠券
const RoyalIndex = resolve => require(['../components/royal/index'], resolve); //皇家首页
const RoyalMassage = resolve => require(['../components/royal/RoyalMassage'], resolve); //皇家按摩页面
const shareIndex = resolve => require(['../components/share/index'], resolve); //摩享时光首页
const ShareMassage = resolve => require(['../components/share/message'], resolve); //摩享时光支付完成界面
const acrule = resolve => require(['../components/shareac/acrule'], resolve); //健康两利界面
const aclogin = resolve => require(['../components/shareac/aclogin'], resolve); //健康两利界面
const acagreement = resolve => require(['../components/shareac/Agreement'], resolve); //健康两利领取规则
const acgetcoupon = resolve => require(['../components/shareac/acgetcoupon'], resolve); //健康两利领取规则
const sLogin = resolve => require(['../components/login/sLogin'], resolve); //分享的登录页面
const scanShareIndex = resolve => require(['../components/scanshare/index'], resolve); //分享的登录页面
const scanShareCount = resolve => require(['../components/scanshare/scanScountdown'], resolve); //分享的登录页面
const scanscoupon = resolve => require(['../components/scanshare/scanSCoupon'], resolve);
const scanslogin = resolve => require(['../components/scanshare/scanslogin'], resolve);
const railWayIndex = resolve => require(['../components/railway/index'], resolve);
const railwayLogin = resolve => require(['../components/railway/railwayLogin'], resolve);
const railwayCoupon = resolve => require(['../components/railway/railwayCoupon'], resolve);
const railwayCountdown = resolve => require(['../components/railway/railwayCountdown'], resolve);
const railBreakdown = resolve => require(['../components/railway/Breakdown'], resolve);
const demoIndex = resolve => require(['../components/demo/yinIndex'], resolve);
const changIndex = resolve => require(['../components/changle/index'], resolve);
const changCountdown = resolve => require(['../components/changle/message'], resolve);
const changBreakdown = resolve => require(['../components/scan/Charging.vue'], resolve);
const yinLogin = resolve => require(['../components/login/yinLogin.vue'], resolve); //银联绑卡
//综合业务线
const comprehensiveLoading = resolve => require(['../components/comprehensive/loader.vue'], resolve);
const comprehensiveIndex = resolve => require(['../components/comprehensive/index.vue'], resolve);
const comprehensiveAgreement = resolve => require(['../components/comprehensive/Agreement.vue'], resolve); //用户协议
const comprehensiveAgreementtwo = resolve => require(['../components/comprehensive/Agreementtwo.vue'], resolve); //用户协议
const comprehensiveCount = resolve => require(['../components/comprehensive/count.vue'], resolve);
const comprehensivePay = resolve => require(['../components/comprehensive/pay.vue'], resolve);
const comprehensiveAgentDetails = resolve => require(['../components/comprehensive/agentDetails.vue'], resolve); //代币明细
const comprehensiveMy = resolve => require(['../components/comprehensive/my.vue'], resolve);
const comprehensiveCoupon = resolve => require(['../components/comprehensive/coupon.vue'], resolve);
const comprehensiveOrder = resolve => require(['../components/comprehensive/order.vue'], resolve);
const comprehensiveWarm = resolve => require(['../components/comprehensive/warm.vue'], resolve);
const comprehensiveMyCoupon = resolve => require(['../components/comprehensive/mycoupon.vue'], resolve);
const unmannedContainer = resolve => require(['../components/unmannedContainer/index.vue'],resolve);//无人货柜
const duibaLogin = resolve => require(['../components/duiba/Login'], resolve);

import { getStore, isWeiXin, isali, setStore, removeStore } from '../config/utils';
import { Toast } from 'mint-ui';

import VueWechatTitle from 'vue-wechat-title'
import Share from 'vue-social-share';
Vue.use(VueWechatTitle);
Vue.use(Share);
Vue.use(Router);
Vue.prototype.$axios = Axios;

const router = new Router({
    mode: 'history',
    // base:'',//将要部署到服务器文件夹路径
    routes: [{
            path: '/',
            name: 'index2',
            component: MineLogin,
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        // 银联绑卡界面
        {
            path: '/yinlogin.html',
            name: 'yinLogin',
            component: yinLogin,
            meta: {
                title: '绑定银行卡',
                keepAlive: false // 不需要被缓存  
            }
        },
        // 长乐机场
        {
            path: '/changBreakdown.html',
            name: 'changBreakdown',
            component: changBreakdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存  绿色-故障界面
            }
        },
        {
            path: '/changindex.html',
            name: 'changIndex',
            component: changIndex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/changCountdown.html',
            name: 'changCountdown',
            component: changCountdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },

        // 长乐机场
        // 测试demo
        {
            path: '/yinindex.html',
            name: 'demoIndex',
            component: demoIndex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        // 测试demo
        //南昌高铁
        {
            path: '/railBreakdown.html',
            name: 'railBreakdown',
            component: railBreakdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/railCountdown.html',
            name: 'railwayCountdown',
            component: railwayCountdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/railwayCoupon.html',
            name: 'railwayCoupon',
            component: railwayCoupon,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/railwayCoupon.html',
            name: 'railwayCoupon',
            component: railwayCoupon,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/railwayLogin.html',
            name: 'railwayLogin',
            component: railwayLogin,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/railway.html',
            name: 'railWayIndex',
            component: railWayIndex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: true //需要被缓存
            }
        },
        //南昌高铁 end
        {
            path: '/royal/index.html',
            name: 'RoyalIndex',
            component: RoyalIndex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/acrule.html',
            name: 'acrule',
            component: acrule,
            meta: {
                title: '规则详情',
                keepAlive: false
            }
        },
        {
            path: '/acagreement.html',
            name: 'acagreement',
            component: acagreement,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false
            }
        },
        {
            path: '/aclogin.html',
            name: 'aclogin',
            component: aclogin,
            meta: {
                title: '摩享时光',
                keepAlive: false
            }
        },
        {
            path: '/acgift.html',
            name: 'acgetcoupon',
            component: acgetcoupon,
            meta: {
                title: '领取礼包',
                keepAlive: false
            }
        },
        // 新增共享界面
        {
            path: '/share/index.html',
            name: 'shareIndex',
            component: shareIndex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },
        {
            path: '/share/massage.html',
            name: 'ShareMassage',
            component: ShareMassage,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false
            }
        },


        {
            path: '/royal/massage.html',
            name: 'RoyalMassage',
            component: RoyalMassage,
            meta: {
                title: '',
                keepAlive: false
            }
        },
        {
            path: '/aiben/login.html',
            name: 'LoginAiben',
            component: LoginAiben,
            meta: {
                title: '活动详情',
                keepAlive: false
            }
        },
        {
            path: '/aiben/index.html',
            name: 'AibenIndex',
            component: AibenIndex,
            meta: {
                title: '加油吧',
                keepAlive: false
            }
        },
        {
            path: '/aiben/coupon.html',
            name: 'AibenCoupon',
            component: AibenCoupon,
            meta: {
                title: '加油吧',
                keepAlive: false
            }
        },
        {
            path: '/aiben/countdown.html',
            name: 'AibenCountdown',
            component: AibenCountdown,
            meta: {
                title: '加油吧',
                keepAlive: false
            }
        },
        {
            path: '/aiben/aibenweihu.html',
            name: 'Aibenweihu',
            component: Aibenweihu,
            meta: {
                title: '加油吧',
                keepAlive: false
            }
        },


        {
            path: '/scan/index.html',
            name: 'index',
            component: Index,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: true // 需要被缓存
            }
        },
        {
            path: '/scan/Coupondraw.html',
            name: 'Coupondraw',
            component: Coupondraw,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scan/Couponshow.html',
            name: 'Couponshow',
            component: Couponshow,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scan/Countdown.html',
            name: 'Countdown',
            component: Countdown,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scan/Charging.html',
            name: 'Charging',
            component: Charging,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scan/Breakdown.html',
            name: 'Breakdown',
            component: Breakdown,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存  橙色-故障界面
            }
        },

        {
            path: '/coupon',
            name: 'fenxiang',
            component: fenxiang,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 为错误的分享界面做的界面
            }
        },
        // 新增的molitest
        {
            path: '/newmoliindex.html',
            name: 'newmoliIndex',
            component: newmoliIndex,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: true
            }
        },
        {
            path: '/newmolilogin.html',
            name: 'newmolilogin',
            component: newmolilogin,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/newmolicoupon.html',
            name: 'newmolicoupon',
            component: newmolicoupon,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/newmoliCountdown.html',
            name: 'newmoliCountdown',
            component: newmoliCountdown,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        // 新增的molitest  newmolilogin


        // {
        //     path: '/moliindex.html',
        //     name: 'moliIndex',
        //     component: moliIndex,
        //     meta: {
        //         title: '智能共享按摩椅',
        //         keepAlive: true
        //     }
        // },
        {
            path: '/moliindex.html',
            name: 'newmoliIndex',
            component: newmoliIndex,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: true
            }
        },

        {
            path: '/moliCoupondraw.html',
            name: 'moliCoupondraw',
            component: moliCoupondraw,
            meta: {
                title: '领取优惠券',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/moliCouponshow.html',
            name: 'moliCouponshow',
            component: moliCouponshow,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/moliCountdown.html',
            name: 'newmoliCountdown',
            component: newmoliCountdown,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        // {
        //     path: '/moliCountdown.html',
        //     name: 'moliCountdown',
        //     component: moliCountdown,
        //     meta: {
        //         title: '智能共享按摩椅',
        //         keepAlive: false // 不需要被缓存
        //     }
        // },
        {
            path: '/moliCharging.html',
            name: 'moliCharging',
            component: moliCharging,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/moliBreakdown.html',
            name: 'moliBreakdown',
            component: moliBreakdown,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存  moli-故障界面
            }
        },
        {
            path: '/moliAgreement.html',
            name: 'moliAgreement',
            component: moliAgreement,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },

        {
            path: '/molicoupon.html',
            name: 'molimineCoupon',
            component: moliMineCoupon,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },

        {
            path: '/share/Breakdown.html',
            name: 'shareBreakdown',
            component: shareBreakdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存  绿色-故障界面
            }
        },
        {
            path: '/royal/Breakdown.html',
            name: 'royalBreakdown',
            component: royalBreakdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存  皇家-故障界面
            }
        },
        {
            path: '/minda/Breakdown.html',
            name: 'mindaBreakdown',
            component: mindaBreakdown,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存  民大-故障界面
            }
        },
        {
            path: '/aiben/Breakdown.html',
            name: 'aibenBreakdown',
            component: aibenBreakdown,
            meta: {
                title: '加油吧',
                keepAlive: false // 不需要被缓存 爱奔-故障界面
            }
        },
        {
            path: '/scan/Agreement.html',
            name: 'Agreement',
            component: Agreement,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/minda/index.html',
            name: 'mindaindex',
            component: mindaindex,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/minda/Countdown.html',
            name: 'mindaCountdown',
            component: mindaCountdowns,
            meta: {
                title: '按摩一下 轻松一刻',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/login.html',
            name: 'login',
            component: Login,
            meta: {
                title: '登录',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/slogin.html',
            name: 'slogin',
            component: sLogin,
            meta: {
                title: '登录',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/molilogin.html',
            name: 'molilogin',
            component: moliLogin,
            meta: {
                title: '登录',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine.html',
            name: 'mine',
            component: MineLogin,
            meta: {
                title: '首页',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/info.html',
            name: 'mineInfo',
            component: MineInfo,
            meta: {
                title: '个人信息',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/point.html',
            name: 'minePoint',
            component: MinePoint,
            meta: {
                title: '我的积分',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/bill.html',
            name: 'mineBill',
            component: MineBill,
            meta: {
                title: '消费记录',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/coupon.html',
            name: 'mineCoupon',
            component: MineCoupon,
            meta: {
                title: '我的优惠券',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/feedback.html',
            name: 'feedback',
            component: Feedback,
            meta: {
                title: '意见反馈',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/guide.html',
            name: 'userGuide',
            component: UserGuide,
            meta: {
                title: '用户指南',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/sharegift.html',
            name: 'sharegift',
            component: sharegift,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/sharerule.html',
            name: 'sharerule',
            component: sharerule,
            meta: {
                title: '奖励规则',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/mine/minegift.html',
            name: 'minegift',
            component: minegift,
            meta: {
                title: '获得奖励',
                keepAlive: false // 不需要被缓存
            }
        },

        {
            path: '/scanshare.html',
            name: 'scanShareIndex',
            component: scanShareIndex,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: true // 需要被缓存
            }
        },
        {
            path: '/scanscount.html',
            name: 'scanShareCount',
            component: scanShareCount,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scanscoupon.html',
            name: 'scanscoupon',
            component: scanscoupon,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/scanslogin.html',
            name: 'scanslogin',
            component: scanslogin,
            meta: {
                title: '智能共享按摩椅',
                keepAlive: false // 不需要被缓存
            }
        },
        /**
         * 综合业务线
         */
        //启动页
        {
            path: '/comprehensiveLoading.html',
            name: 'comprehensiveLoading',
            component: comprehensiveLoading,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        //首页
        {
            path: '/comprehensive.html',
            name: 'comprehensive',
            component: comprehensiveIndex,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        //用户协议
        {
            path: '/comprehensiveAgreement.html',
            name: 'comprehensiveAgreement',
            component: comprehensiveAgreement,
            meta: {
                title: '用户协议',
                keepAlive: false // 不需要被缓存
            }
        },
        //M豆购买协议
        {
            path: '/comprehensiveAgreementtwo.html',
            name: 'comprehensiveAgreementtwo',
            component: comprehensiveAgreementtwo,
            meta: {
                title: '用户协议',
                keepAlive: false // 不需要被缓存
            }
        },
        //倒计时
        {
            path: '/comprehensiveCount.html',
            name: 'count',
            component: comprehensiveCount,
            meta: {
                title: '享受这一刻',
                keepAlive: false // 不需要被缓存
            }
        },
        //支付
        {
            path: '/comprehensivePay.html',
            name: 'pay',
            component: comprehensivePay,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        //订单明细
        {
            path: '/comprehensiveAgentDetails.html',
            name: 'comprehensiveAgentDetails',
            component: comprehensiveAgentDetails,
            meta: {
                title: 'M豆明细',
                keepAlive: false // 不需要被缓存
            }
        },
        //个人中心
        {
            path: '/comprehensiveMy.html',
            name: 'my',
            component: comprehensiveMy,
            meta: {
                title: '个人中心',
                keepAlive: false // 不需要被缓存
            }
        },
        //确认订单页面
        {
            path: '/comprehensiveCoupon.html',
            name: 'confirmOrder',
            component: comprehensiveCoupon,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/comprehensiveOrder.html',
            name: 'order',
            component: comprehensiveOrder,
            meta: {
                title: '我的订单',
                keepAlive: false // 不需要被缓存
            }
        },
        //设备报错提示
        {
            path: '/warm.html',
            name: 'comprehensiveWarm',
            component: comprehensiveWarm,
            meta: {
                title: '摩享时光',
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '/comprehensiveMycoupon.html',
            name: 'mycoupon',
            component: comprehensiveMyCoupon,
            meta: {
                title: '优惠劵列表',
                keepAlive: false // 不需要被缓存
            }
        },
        /**
         * 无人货柜
         */
        {
            path: '/unmannedContainer.html',
            name: 'unmannedContainer',
            component: unmannedContainer,
            meta: {
                title: '',
                keepAlive: false // 不需要被缓存
            }
        },
        /**
         * 兑吧版本
         */
        {
            path: '/duibaLogin.html',
            name: 'duibaLogin',
            component:duibaLogin,
            meta: {
                title: '登录',
                keepAlive: false // 不需要被缓存
            }
        },
    ]
});
export default router;
router.beforeEach(function(to, from, next) { //微信公总号项目
    const nextRoute = ['mineCoupon', 'mineBill', 'minePoint', 'feedback', 'mineLogin', "minegift"];
    // , "sharegift"暂时不限制 
    //跳转至上述3个页面
    let username = getStore("loginInfo");
    let openId = getStore("openId");
    let curOpenId = to.query.openId ? to.query.openId : to.query.code;
    if (curOpenId) {
        if (openId !== curOpenId) {
            removeStore("loginInfo");
            username = '';
        }
        setStore("openId", curOpenId);
        openId = curOpenId;
    }
    // removeStore("openId");
    // removeStore("loginInfo");
    let jumpToUrl = window.location.hostname == "xy.cozzia.com.cn" ? "https://xy.cozzia.com.cn/login.html" : "https://wxchart.cozzia.com.cn/login.html";
    //如果没有登录，打开登录页面受限去授权拿到openid
    if (!openId && to.name === "login") {
        if (isWeiXin()) {
            // https://wxchart.cozzia.com.cn/login.html
            // window.location.href = process.env.API_ROOT + 'user/oauth?clientType=1&callbackUrl=' + encodeURIComponent("http://101.201.196.238/login");
            // window.location.href = process.env.API_ROOT + 'user/oauth?clientType=1&callbackUrl=' + encodeURIComponent("http://60.205.180.149/login.html");
            window.location.href = process.env.API_ROOT + 'user/oauth?clientType=1&callbackUrl=' + encodeURIComponent(jumpToUrl);
            // 正式线 60.205.180.149/login.html
            // 测试线http://101.201.196.238
            return false;
        }
    }
    //如果是阿里浏览器，打开优惠券页面首先去授权
    if (isali() && to.name === "login") {
        if (to.name === 'mineCoupon') {
            // https://wxchart.cozzia.com.cn/login.html
            window.location.href = process.env.API_ROOT + 'user/oauth?clientType=2&callbackUrl=' + encodeURIComponent(jumpToUrl);
            // window.location.href = process.env.API_ROOT + 'user/oauth?clientType=2&callbackUrl=' + encodeURIComponent("http://39.108.155.77/login.html");
            return false;
        }
    }
    if (nextRoute.indexOf(to.name) >= 0 && to.name !== "login") {
        //未登录
        if (username == null || username.length === 0) {
            console.log("to.fullPath:" + to.fullPath)
            router.push({
                path: '/login.html',
                query: { redirect: to.fullPath } // 如果你使用钩子函数，your path 可以替换成to.fullPath
            });
        }
    }
    next();
});



// WEBPACK FOOTER //
// ./src/router/index.js